import React from "react";
import HelpModal from "common/HelpModal.jsx";

const UsersAdminHelpModal = () => (
  <HelpModal
    title="NTP Servers"
    content={() => (
      <>
        <p>List of available users:</p>
        <ul>
          <li>
            <b>USERNAME</b>: User name.
          </li>
          <li>
            <b>PROFILE</b>: User profile.
          </li>
          <ul>
            <li>
              <b>administrator</b>: Full access to BQN node OAM capabilities.
            </li>
            <li>
              <b>operator</b>: Restricted access. Configuration changes are not
              possible, including user management.
            </li>
          </ul>
          <li>
            <b>DESCRIPTION</b>: Text describing the user.
          </li>
          <li>
            <b>ACTIONS</b>: Allowed operations on the user.
          </li>
        </ul>
        <p>
          Click on the <i className="material-icons valign-icon">lock</i> icon
          to change a user password.
        </p>
        <p>
          Click on the <i className="material-icons valign-icon">delete</i> icon
          to delete an existing user.
        </p>
        <p>
          Press the <i className="material-icons valign-icon">more_vert</i> icon
          and then select the <b>Add User...</b> option to add a new user.
        </p>
        <p>
          Click on the <i className="material-icons valign-icon">refresh</i>{" "}
          icon to refresh user information.
        </p>
      </>
    )}
  />
);

export default UsersAdminHelpModal;
